import React, { useState } from 'react';
import EmployeeTable from './EmployeeTable';
import { Users, ChevronDown } from 'lucide-react';

const CampaignCard = ({
  campaign,
  isExpanded,
  onToggle,
  refetch,
}) => {
  const [employees, setEmployees] = useState(campaign.Employees);

  const handleEmployeeRemoved = (employeeId) => {
    setEmployees((prev) => prev.filter((emp) => emp.EmployeeId !== employeeId));
  };

  return (
    <div className="card bg-base-100 shadow-lg hover:shadow-xl transition-shadow duration-200">
      <div className="card-body">
        {/* Campaign Header */}
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={onToggle}
        >
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h2 className="card-title text-xl">{campaign.CampaignName}</h2>
              <div className="badge badge-primary badge-sm">
                ID: {campaign.CampaignId}
              </div>
            </div>
            <div className="flex items-center gap-4 text-sm text-base-content/70">
              <span className="flex items-center gap-1">
                <Users className="w-4 h-4" />
                {campaign.Employees.length} employee
                {campaign.Employees.length !== 1 ? 's' : ''}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button className="btn btn-ghost btn-sm">
              <ChevronDown
                className={`h-6 w-6 ${isExpanded ? 'rotate-180' : ''}`}
              />
            </button>
          </div>
        </div>

        {/* Expanded Content */}
        {isExpanded && (
          <div className="mt-6 border-t pt-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Team Members</h3>
              <div className="text-sm text-base-content/70">
                Total: {campaign.Employees.length}
              </div>
            </div>
            <EmployeeTable
              employees={employees}
              campaignId={campaign.CampaignId}
              onEmployeeRemoved={handleEmployeeRemoved}
              refetch={refetch}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignCard;
